import { t } from 'i18next';
import { get } from 'lodash';

import { showConfirmDialog } from './messageDialog';
import { showModal, TYPES } from './modal';
import { NotificationTypes, pushNotification } from './notifications';
import { setLoadingState } from './progressIndicator';
import { MessageDialogTypes } from '../components/MessageDialog/MessageDialog';
import { MessageType } from '../service/constants';
import { UNAUTHORIZED_HTTP_CODE } from '../service/Error';
import errorLogsSender from '../service/ErrorLogsSender';
import { getErrorMessage, getTranslateText } from '../service/utils';

export const CANCEL_DELETE_SERVICE_DATA = 'CANCEL_DELETE_SERVICE_DATA';
export const CANCEL_OPERATION = 'CANCEL_OPERATION';
export const DELETE_SERVICE_DATA = 'DELETE_SERVICE_DATA';
export const END_OPERATION = 'END_OPERATION';
export const SAVE_SERVICE_DATA = 'SAVE_SERVICE_DATA';
export const SINGLE_OPERATION = 'SINGLE_OPERATION';
export const START_OPERATION = 'START_OPERATION';
export const UPDATE_AIRPORT_SERVICE = 'UPDATE_AIRPORT_SERVICE';
export const UPDATE_SENDED_SERVICE_DATA = 'UPDATE_SENDED_SERVICE_DATA';

const createAction = (type) => (legId, id) => ({ type, legId, id });

export const startOperation = createAction(START_OPERATION);
export const singleOperation = createAction(SINGLE_OPERATION);
export const endOperation = createAction(END_OPERATION);
export const cancelOperation = createAction(CANCEL_OPERATION);
export const cancelDeleteServiceData = createAction(CANCEL_DELETE_SERVICE_DATA);

export const deleteServiceData = (legId, id) => (dispatch) =>
    dispatch(
        showConfirmDialog({
            title: t('confirmationDialog'),
            message: t('airportServices.confirmDeleteServices'),
        })
    ).then((isOk) => {
        if (isOk) {
            dispatch({ type: DELETE_SERVICE_DATA, legId, id });
        }
    });

const downloadServiceData =
    (legId, userId) =>
    (dispatch, getState, { apiManager }) => {
        dispatch(setLoadingState(true, t('messages.downloadAirportService')));

        return apiManager.getAirportServiceData(legId, userId).catch((err) => {
            if (err.errorCode === UNAUTHORIZED_HTTP_CODE) {
                dispatch(showModal(TYPES.RELOGIN, {}));
                return;
            }

            throw err;
        });
    };

export const downloadAirportService = (legId) => (dispatch, getState) => {
    const state = getState();
    const userId = get(state, 'login.user.id');

    const servicePromise = dispatch(downloadServiceData(legId, userId));

    return Promise.all([servicePromise])
        .then(([data]) => {
            if (!data) {
                return;
            }

            const airportServices = data.reduce((res, item) => {
                res[item.id] = { ...item };

                return res;
            }, {});

            return Promise.all([
                dispatch({
                    type: UPDATE_AIRPORT_SERVICE,
                    data: { [legId]: airportServices },
                }),
            ]);
        })
        .catch((err) => {
            dispatch(
                showConfirmDialog({
                    title: t('errMessage'),
                    message: t('errors.getData'),
                    btnCancelVisibility: false,
                    options: {
                        type: MessageDialogTypes.ERROR,
                    },
                })
            );
            const error = new Error(getErrorMessage(err, MessageType.GET_AIRPORT_SERVICE_API), {
                cause: err,
            });
            errorLogsSender.addLog(error);
            throw error;
        })
        .finally(() => dispatch(setLoadingState(false)));
};

export const saveAirportServiceData = (legId, data) => {
    data.isEdited = true;

    return {
        type: SAVE_SERVICE_DATA,
        legId,
        service: data,
    };
};

export const updateAirportServicesAfterSaving = (legsData) => (dispatch) => {
    if (!legsData) return;

    const deletedServices = Object.values(legsData)
        .flatMap(({ airportServices }) => airportServices?.filter(({ isDeleted, lock, name }) => (isDeleted || lock) && name) ?? [])
        .map((item) => getTranslateText('name', item));

    if (deletedServices && deletedServices.length) {
        dispatch(
            pushNotification({
                variant: NotificationTypes.ERROR,
                message: t('airportServices.notExistOrLockOperations'),
                details: deletedServices.join('\n'),
            })
        );
    }

    return dispatch({
        type: UPDATE_SENDED_SERVICE_DATA,
        legsData,
    });
};
